import {
  getScrollTop,
  getScrollEventTarget,
  scrollTo,
  scrollContainerMediaQuery,
} from '@theme/scroll-container';

const THRESHOLD = 200;
const button = document.querySelector('.scroll-to-top');

if (button) {
  let scrollTarget = getScrollEventTarget();

  function updateVisibility() {
    const visible = getScrollTop() > THRESHOLD;
    button.classList.toggle('scroll-to-top--visible', visible);
    button.toggleAttribute('hidden', !visible);
  }

  scrollTarget.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();

  button.addEventListener('click', () => {
    scrollTo({ top: 0, behavior: 'smooth' });
  });

  scrollContainerMediaQuery.addEventListener('change', () => {
    scrollTarget.removeEventListener('scroll', updateVisibility);
    scrollTarget = getScrollEventTarget();
    scrollTarget.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
  });
}
